export default {
  nav: {
    brand: "USFans Link",
    home: "Home",
    categories: "Categories",
    guides: "Guides",
    faq: "FAQ",
    explore: "Explore Spreadsheet",
    shoppingGuide: "Shopping Guide",
  },
  hero: {
    eyebrow: "USFans Spreadsheet Resource Center",
    title: "Explore the USFans Spreadsheet: Categories, Guides & Resources",
    description:
      "Discover an organized hub for the USFans Spreadsheet — browse fashion categories, read practical guides, compare resources and find everything you need in one calm, easy-to-navigate place.",
    trust: "Independent Resource • Updated Regularly • Easy to Navigate • Safety-Focused",
    searchPlaceholder: "Search creators, categories, guides or topics...",
  },
  main: {
    usfansSpreadsheet: "USFans Spreadsheet",
    buyNow: "Buy It Now",
  },
  dropdown: {
    label: "Jump to a category",
    placeholder: "Choose a category...",
  },
  categoriesSection: {
    title: "Browse Categories",
    subtitle:
      "Explore the full range of fashion and lifestyle categories, each linking to the matching section on the main website.",
    browseAll: "Browse all categories",
  },
  categories: {
    shoes: "Shoes",
    hoodies: "Hoodies/Sweaters",
    tshirts: "T-Shirts",
    jackets: "Jackets",
    pants: "Pants/Shorts",
    headwear: "Headwear",
    sets: "Sets",
    underwear: "Underwear/Underpants",
    jersey: "Jersey",
    accessories: "Accessories",
    bags: "Bags",
    belts: "Belts",
    perfumes: "Perfumes",
    other: "Other Stuff",
  },
  what: {
    title: "What Is the USFans Spreadsheet?",
    p1: "The USFans Spreadsheet is a structured resource that makes USFans-related information easier to discover, compare and understand. Instead of searching across scattered pages, you can explore organized categories covering shoes, hoodies, jackets, accessories and more.",
    p2: "It works as a friendly starting point: scan the category list, pick what interests you, and follow a clear link to the main website whenever you are ready to see more.",
    cta: "Learn More About USFans Spreadsheet",
  },
  why: {
    title: "Why Use This Resource?",
    subtitle: "A calm, organized way to browse — built for speed and clarity.",
    c1title: "Organized Information",
    c1desc: "Categories are grouped so you can find the right section in seconds.",
    c2title: "Easy Discovery",
    c2desc: "A simple dropdown and clear buttons make browsing effortless.",
    c3title: "Useful Comparisons",
    c3desc: "See categories side by side to decide where to look next.",
    c4title: "Safety-Focused",
    c4desc: "Clear guidance helps you browse and follow links with confidence.",
  },
  guides: {
    title: "Latest Guides",
    subtitle:
      "Original, practical articles about the USFans Spreadsheet and how to get the most from it.",
    readMore: "Read the guide",
    comingSoon: "Coming soon",
    comingTitle1: "USFans Review: What to Know",
    comingExcerpt1: "A closer look at features, pros and cons, and practical considerations.",
    comingCategory1: "Review",
    comingTitle2: "USFans Shipping Cost Guide",
    comingExcerpt2: "Shipping factors, pricing and delivery considerations explained.",
    comingCategory2: "Shipping",
  },
  faq: {
    title: "Frequently Asked Questions",
    subtitle: "Quick answers to common questions about the USFans Spreadsheet.",
    q1: "What is the USFans Spreadsheet?",
    a1: "It is a structured resource that groups fashion and lifestyle categories into one easy-to-browse view with clear links to the main website.",
    q2: "How do I browse the categories?",
    a2: "Use the dropdown selector or the category buttons on the homepage. Both lead to the matching section on the main website.",
    q3: "Is the USFans Spreadsheet free to use?",
    a3: "Yes, browsing is completely free and no account is required.",
    q4: "How often is the information updated?",
    a4: "The resource is refreshed regularly to keep category links accurate and up to date.",
    q5: "Where do the category links lead?",
    a5: "Each link leads to the corresponding category section on the main website.",
    q6: "How can I stay safe while browsing?",
    a6: "Verify the website address, keep login and payment details private, and avoid sharing personal information with untrusted sources.",
  },
  cta: {
    title: "Start Exploring the USFans Spreadsheet",
    desc: "Find organized categories, practical guides and useful resources in one place.",
    primary: "Explore USFans Spreadsheet",
    secondary: "Visit the Main Website",
  },
  footer: {
    about:
      "USFans Link is an independent resource center built around the USFans Spreadsheet, helping visitors browse categories, read guides and find useful information.",
    quickLinks: "Quick Links",
    categories: "Categories",
    resources: "Resources",
    guides: "Guides",
    faq: "FAQ",
    home: "Home",
    rights: "All rights reserved.",
    disclaimer:
      "USFans Link is an independent resource and is not affiliated with the main website. Product links lead to the official store.",
  },
  notFound: {
    title: "Page Not Found",
    desc: "The page you're looking for doesn't exist or has moved. Head back to the homepage to keep browsing.",
  },
};